<pbc-sorter [config]="MitarbeiterSorterConfig" [sorter]="mitarbeiter.sorter$ | async" (sorterChange)="mitarbeiter.sorter$.next($event)"></pbc-sorter>
